import { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { serverFetch } from '@server';
import { dictsLoaded } from '@redux/actions';
import { showError } from './utils';

// Виды каналов связи (ChannelVid на сервере)
export const CHANNEL_VIDS = [
    { value: 1, label: 'Telegram' },
    { value: 3, label: 'Max (бот)' },
    { value: 5, label: 'ВКонтакте' },
    { value: 13, label: 'Max (Wappi)' },
    { value: 15, label: 'Билайн' },
    { value: 17, label: 'Telegram (Wappi)' },
    { value: 201, label: 'Чат на сайте' },
];

export const CHANNEL_MAX_WAPPI = 13;
export const CHANNEL_BEELINE = 15;
export const CHANNEL_TG_WAPPI = 17;

export const channelVidName = (vid) =>
    CHANNEL_VIDS.find((c) => c.value === vid)?.label ?? `Канал ${vid}`;

const emptyDicts = {
    users: [], statuses: [], tags: [], departments: [],
    orderStatuses: [], cashboxes: [], products: [], productGroups: [], projects: [], versions: [], blocks: [],
};

async function loadDicts() {
    const [users, statuses, tags, departments, orderStatuses, cashboxes, products, productGroups, projects, versions, blocks] = await Promise.all([
        serverFetch('user').catch(() => []),
        serverFetch('status?vid=4').catch(() => []),
        serverFetch('tag').catch(() => []),
        serverFetch('department').catch(() => []),
        serverFetch('status?vid=5').catch(() => []),
        serverFetch('cashbox').catch(() => []),
        serverFetch('product').catch(() => []),
        serverFetch('productgroup').catch(() => []),
        serverFetch('project').catch(() => []),
        serverFetch('version').catch(() => []),
        serverFetch('block').catch(() => []),
    ]);
    return { users, statuses, tags, departments, orderStatuses, cashboxes, products, productGroups, projects, versions, blocks };
}

// Хук справочников: грузит один раз после входа, reloadDicts() перезагружает
export function useDicts() {
    const dispatch = useDispatch();
    const user = useSelector((s) => s.user);
    const dicts = useSelector((s) => s.dicts);

    const reloadDicts = useCallback(() => {
        return loadDicts()
            .then((d) => dispatch(dictsLoaded(d)))
            .catch(showError);
    }, [dispatch]);

    useEffect(() => {
        if (user && user.companyId != null && dicts == null) {
            reloadDicts();
        }
    }, [user, dicts, reloadDicts]);

    return { dicts: dicts ?? emptyDicts, reloadDicts };
}
